import { render, staticRenderFns } from "./ConfirmCampaignUpdateDialog.vue?vue&type=template&id=57c22dd4&scoped=true&"
import script from "./ConfirmCampaignUpdateDialog.vue?vue&type=script&lang=ts&"
export * from "./ConfirmCampaignUpdateDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmCampaignUpdateDialog.vue?vue&type=style&index=0&id=57c22dd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c22dd4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCol,VDialog,VRow,VSpacer})
